import { schema } from "normalizr";

export const portfolio = new schema.Entity("portfolio");
export const portfolioList = [portfolio];
